export const SCREENS = {
  WORKSPACE: 'WORKSPACE',
  BOARD: 'BOARD',
  SETTINGS: 'SETTINGS',
};

export const STAGES = {
  THINK: 'THINK',
  GROUP: 'GROUP',
  VOTE: 'VOTE',
  DISCUSS: 'DISCUSS',
  SUMMARY: 'SUMMARY',
};
